import { render, staticRenderFns } from "./blank-header.vue?vue&type=template&id=7007eb4a"
var script = {}
import style0 from "./blank-header.vue?vue&type=style&index=0&id=7007eb4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports